export default {
  checkoutInformation: {},
  installments: {},
  cardPaymentInformation: {}
}